import { BaseMembersProps, MembersSortBy } from "@custom-types/member-types";
import {
  BulkButtonComponents,
  MemberTableSubject,
} from "@components/common/faro-table/faro-table-types";
import { useMembersMenuOptions } from "@pages/members/use-members-menu-options";
import { InviteMemberToCompany } from "@pages/members/invite-member-to-company";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { MemberMobileList } from "@components/common/mobile/member-mobile-list";
import { useSetMemberTableType } from "@hooks/table/use-set-member-table-type";

interface Props extends BaseMembersProps {
  /** List of all the bulk actions and callbacks */
  bulkActionButtons: BulkButtonComponents;

  /** Whether the data for showing a table is loading or not */
  isLoading: boolean;

  /** Recognizes on which context the table is being used */
  tableSubject: MemberTableSubject;

  /** Current sort by value from the sort dropdown */
  sortBy: MembersSortBy;
}

/**
 * Mobile-specific view for members list.
 * Renders a virtualized list of members with selection, menu options, and bulk actions.
 */
export function MembersMobileView({
  members,
  bulkActionButtons,
  isLoading,
  tableSubject,
  sortBy,
}: Props): JSX.Element | null {
  useSetMemberTableType(tableSubject);

  const menuItems = useMembersMenuOptions({ subjectType: tableSubject });
  const { canInviteUsersToCompany } = useHasUserValidRoleCompanyLevel();

  return (
    <MemberMobileList
      members={members}
      isLoading={isLoading}
      bulkActionButtons={bulkActionButtons}
      tableSubject={tableSubject}
      menuItems={menuItems}
      renderFooterExtra={() => <InviteMemberToCompany buttonVariant="filled" />}
      shouldShowFooterExtra={canInviteUsersToCompany}
      sortBy={sortBy}
    />
  );
}
